// extracted by mini-css-extract-plugin
module.exports = {"highlighted":"popup-pages_highlighted__37vRx","ldap":"popup-pages_ldap__zl5ap","right":"popup-pages_right__23jKg"};